function bandeauService(authService, $http) {
    var vm = this;

    vm.authInfos = authService.getAuthInfos();
    vm.nim = null;
    vm.storeid = null;
    if (vm.authInfos && vm.authInfos.data.data) {
        vm.nim = vm.authInfos.data.data.nim;
        vm.storeid = vm.authInfos.data.data.identifiant_magasin;
    }
    vm.data = '';

    vm.getMessages = function () {
        return $http
            .get('bandeau://' + vm.storeid + '/messages/portail')
            .then(function (res) {
                return res.data;
            })
            .catch(function () {
                return false;
            });
    };

    return vm;
}
angular.module('app.portail.common').factory('bandeauService', bandeauService);
